<template>
  <div :class="`formulate-input-element formulate-input-element--${context.type} ml-1`" :data-type="context.type">
    <toggle-button v-bind="context.attributes" v-model="_value" :labels="_labels" :font-size="14" :speed="100" :sync="true" :height="30" :width="width" />
  </div>
</template>

<script>
import { ToggleButton } from 'vue-js-toggle-button'
export default {
  components: {
    ToggleButton
  },
  props: {
    context: {
      type: Object,
      required: true
    },
    width: {
      type: Number,
      default: 60
    }
  },
  computed: {
    _value: {
      get() {
        return !!this.context.model
      },
      set(value) {
        this.context.model = value
        this.context.blurHandler()
      }
    },
    _labels() {
      return {
        checked: this.context.attributes.onLabel ?? 'On',
        unchecked: this.context.attributes.offLabel ?? 'Off'
      }
    }
  }
}
</script>

<style lang="postcss" scoped>
.formulate-input-element >>> .vue-js-switch.disabled {
  @apply cursor-not-allowed pointer-events-auto;
}
</style>
